<template>
  <div class="rule-box">
    <!-- <v-head :title="title"></v-head>
    <van-collapse v-model="activeNames" accordion>
      <van-collapse-item title="总 则" name="1">
        <div class="content">为了加强学会对会员的管理和服务，根据《社会团体登记管理条例》和《中国声学学会章程》，特制定本条例。</div>
      </van-collapse-item>
      <van-collapse-item title="会 员" name="2">
        <div class="content">
          <p>
            <b>第一条</b>会员是学会的主体。拥护、承认本学会章程，热心和支持学会工作，均可自愿申请加入本学会。本会会员包括个人会员和单位会员。其中个人会员包含：学生会员、普通会员、高级会员、会士、通讯会员。单位会员即团体会员。
          </p>
          <p>
            <b>第二条</b>申请加入本会会员的条件：
          </p>
          <ul>
            <li>
              <b>(一)</b>
              普通会员：具有中级以上专业技术职务或职称(含中级)或硕士以上学位(含硕士)的声学科技工作者，或高等院校本科毕业生，在科研、教学、生产、企事业单位从事本学科相关工作三年以上者；从事本学科组织管理工作者、科普工作者、领导干部和企业家。由本人提出申请，由本会会员两人或理事一人介绍。
            </li>
            <li>
              <b>(二)</b>
              学生会员：与声学有关的硕士研究生和本科三年级以上的学生，由本人提出申请、本会会员两人或理事一人介绍。
            </li>
            <li>
              <b>(三)</b>
              高级会员：已获得高级工程师、副教授、副研究员以上职称或在声学科学技术领域中成绩显著，学术上有较高造诣的声学科技人员，并具有三年以上个人会员会龄，由本人提出申请、本会两名会士或高级会员书面推荐。
            </li>
            <li>
              <b>(四)</b>
              会士：凡对本学会和声学科学技术有杰出贡献、具有正高级职称的会员，并具有三年以上高级会员会龄，由本人提出申请、本会两名会士书面推荐。
            </li>
            <li>
              <b>(五)</b>
              通讯会员：港澳台地区和侨居国外符合本会章程规定个人会员条件，从事声学工作的专家和学者，在学术上有较高成就对我国友好的外籍学者，由本人提出申请、本会会员两人或理事一人介绍。
            </li>
            <li>
              <b>(六)</b>
              单位会员：凡与本会专业范围有关的科研、教学、生产、设计等企事业单位，以及相关依法登记的学术性社会团体，拥护本会章程，支持本会工作，愿意参加本会活动，均可申请为单位会员。
            </li>
          </ul>
        </div>
      </van-collapse-item>
      <van-collapse-item title="入会与退会" name="3">
        <div class="content">
          <p>
            <b>第三条</b> 申请加入本会的科研、教学单位、企事业和社会团体等组织及个人，应履行下列申请入会手续（详情见本会网站《入会指南》：
          </p>
          <ul>
            <li>
              <b>(一)</b>
              个人会员：填写《中国声学学会会员申请表》，将申请表、推荐信、个人身份证复印件等纸质材料一同报学会办公室，由学会常务理事会授权学会办公室进行资格审查后批准；入会申请材料可以邮寄，也可以通过学会网站以在线申请的方式向学会办公室提交。
            </li>
            <li>
              <b>(二)</b>
              单位会员：填写《中国声学学会单位会员申请表》，并将申请表及企业营业执照（或社团法人登记证书）复印件等材料（均加盖公章）提交学会办公室。
            </li>
            <li>
              <b>(三)</b>
              申请入会的被批准后，即由学会办公室通知申请人在30日内办理会员注册手续，颁发会员证，在本学会网站上予以公布。
            </li>
          </ul>
          <p>
            <b>第四条</b>本会会员也可以是归属地地方学会的会员。
          </p>
          <p>
            <b>第五条</b>会员提出变更会员类别、会员信息，可本会网站进行在线申请。学会办公室收到会员的变更申请后，参照不同类别会员的申请办法办理相关变更手续或进行信息变更登记。
          </p>
          <p>
            <b>第六条</b>中国声学学会会员有退会的自由，会员退会按如下条例办理：
          </p>
          <ul>
            <li>
              <b>(一)</b>
              会员要求退会时，应书面通知学会办公室并交回会员证；
            </li>
            <li>
              <b>(二)</b>
              会员凡触犯刑律或严重违反本会章程者，经常务理事会决定予以取消会籍；
            </li>
            <li>
              <b>(三)</b>
              单位会员如严重违反国家有关法律法规，受到国家有关主管部门停业整顿、暂扣和吊销其许可证、营业执照等处罚，或严重违反本学会章程以及本办法的规定的，由学会办公室报（常务）理事会，由（常务）理事会视不同情况给予其警告、取消会员单位资格的处理；
            </li>
            <li>
              <b>(四)</b>
              单位会员如两年不参加学会及专委会组织的任何活动，取消其会员资格；
            </li>
            <li>
              <b>(五)</b>
              会员、单位会员如无正当理由不交纳会费并经提示后仍未交会费的视为自动退会，取消其会员资格；
            </li>
            <li>
              <b>(六)</b>
              会员退会或被取消会员资格的，由学会办公室在学会网站上定期公布，其原享有的会员权利亦自动终止。
            </li>
          </ul>
        </div>
      </van-collapse-item>
      <van-collapse-item title="会员的权利与义务" name="4">
        <div class="content">
          <p>
            <b>第七条</b>中国声学学会会员享有如下权利：
          </p>
          <ul>
            <li>
              <b>(一)</b>
              会员有选举权、被选举权和表决权(学生会员除外)；
            </li>
            <li>
              <b>(二)</b>
              对本会工作情况和工作计划的知情权；
            </li>
            <li>
              <b>(三)</b>
              对本会工作有建议权、批评权和监督权；
            </li>
            <li>
              <b>(四)</b>
              优先参加本会有关学术活动；
            </li>
            <li>
              <b>(五)</b>
              优先取得本会有关的学术信息资料；
            </li>
            <li>
              <b>(六)</b>
              以折扣价订阅由本会主办的刊物；
            </li>
          </ul>
          <p>
            <b>第八条</b>单位会员还享有如下权利：
          </p>
          <ul>
            <li>
              <b>(一)</b>
              可推荐人选参加本学会及专业委员会举办的各项活动，参与赞助优秀论文评选及其它表彰活动；
            </li>
            <li>
              <b>(二)</b>
              可要求学会优先给予技术咨询；
            </li>
            <li>
              <b>(三)</b>
              可请本会协助其单位举办技术培训班等活动；
            </li>
            <li>
              <b>(四)</b>
              应邀可参加学会理事扩大会议。
            </li>
            <li>
              <b>(五)</b>
              入会自愿，退会自由。
            </li>
          </ul>
          <p>
            <b>第九条</b>中国声学学会会员应履行如下义务：
          </p>
          <ul>
            <li>
              <b>(一)</b>
              遵守本学会章程，执行本学会决议，维护本学会合法权益；
            </li>
            <li>
              <b>(二)</b>
              接受学会委托的工作，协助学会开展有关学术和科普活动；
            </li>
            <li>
              <b>(三)</b>
              积极宣传并参加本学会的各项活动；
            </li>
            <li>
              <b>(四)</b>
              积极撰写学术论文和参加学会活动；
            </li>
            <li>
              <b>(五)</b>
              按规定交纳会费；
            </li>
            <li>
              <b>(六)</b>
              会员信息变动时，应及时通知学会。
            </li>
          </ul>
          <p>
            <b>第十条</b>通讯会员的权利和义务：
          </p>
          <ul>
            <li>
              <b>(一)</b>
              优惠或免费得到学会出版的学术刊物和有关资料；
            </li>
            <li>
              <b>(二)</b>
              优先参加学会在国内主办的学术会议；
            </li>
            <li>
              <b>(三)</b>
              优先参加学会举办的国际性学术会议；
            </li>
            <li>
              <b>(四)</b>
              支持学会工作，交换学术资料，沟通信息，完成学会委托的任务，如协助开展国际学术活动，推荐专家来华讲学等；
            </li>
            <li>
              <b>(五)</b>
              定期缴纳会费；
            </li>
            <li>
              <b>(六)</b>
              通讯会员不享有选举权和被选举权；
            </li>
            <li>
              <b>(七)</b>
              外籍通讯会员需报业务主管单位核准备案。
            </li>
          </ul>
        </div>
      </van-collapse-item>
      <van-collapse-item title="会费与使用" name="5">
        <div class="content">
          <p>
            <b>第十一条</b> 会费标准的制定由中国声学学会会员代表大会表决通过，会费的收缴由学会办公室办理，在学会网站上及时公布交费情况。
          </p>
          <ul>
            <li>
              <b>(一)</b>
              普通个人会员100元/年/人，高级会员会费300元/年/人，会士会费400元/年/人，单位会员会费2000元/年/个；
            </li>
            <li>
              <b>(二)</b>
              每年的第一季度缴纳当年会费，亦可一次性缴纳会费至学会届满；
            </li>
            <li>
              <b>(三)</b>
              新批准入会的个人会员和会员单位，应按照上述会费标准于登记注册时一次性交纳当年会费，如入会日期是下半年，则按半年交纳。以后每年在第一季度交纳；
            </li>
          </ul>
          <p>
            <b>第十二条</b> 中国声学学会会费的使用，本着取之于会员用之于会员的原则,会费的收取和管理由本学会办公室负责。办公室建立健全财务制度，配备专(兼)职财会人员，设立会费收支帐册，接受审计和社团登记管理部门的监督、检查，并向会员代表大会报告财务收支状况。
          </p>
          <p>
            <b>第十三条</b> 本协会会费标准的制定由学会会员代表大会半数以上通过方可实施。
          </p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="会籍管理" name="6">
        <div class="content">
          <p>
            <b>第十四条</b> 中国声学学会会籍由中国声学学会统一管理。
          </p>
          <ul>
            <li>
              <b>(一)</b>
              凡本会会员均由总会统一颁发中国声学学会会员证，会员分类分级管理；
            </li>
            <li>
              <b>(二)</b>
              在各省、市地方声学学会申请入会的会员，希望会员所在地域的地方学会向总会提供会员所有信息，以便将该会员的信息录入总会的会员管理系统。
            </li>
          </ul>
          <p>
            <b>第十五条</b> 中国声学学会个人会员证书和单位会员证书由学会办公室统一制作和颁发。
          </p>
          <p>
            <b>第十六条</b> 中国声学学会学会办公室建立会员管理数据库，定期修改和补充数据库。
          </p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="附 则" name="7">
        <div class="content">
          <p>
            <b>第十七条</b>本条例的解释权归中国声学学会办公室。
          </p>
          <p>
            <b>第十八条</b> 本条例自（常务）理事会通过之日起执行。
          </p>
        </div>
      </van-collapse-item>
    </van-collapse> -->
    <registerRule></registerRule>
  </div>
</template>

<script>
import vHead from "../components/Subhead.vue";
import { Collapse, CollapseItem } from "vant";
import registerRule from "wordsPath/registerRule.vue";
export default {
  data() {
    return {
      activeNames: '1',
      title:"入会须知"
    };
  },
  components: {
    vHead,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    registerRule
  }
};
</script>

<style lang="less" scoped>
.content{font-size:14px; line-height: 2; color: #333;}
p {
  margin-bottom: 10px;
  
   color: #333;
}
b {
  font-weight: bold;
  margin-right: 10px;
}
ul {
  li {
    margin: 5px 0;
    font-size:13px;
     color: #666;
  }
}
/deep/.van-cell{ padding:15px 20px;}
</style>

